var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[_c('GmapMap',{staticClass:"map",attrs:{"center":{ lat: _vm.lat, lng: _vm.lng },"zoom":15,"options":{
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: true,
      fullscreenControl: true,
      disableDefaultUi: true,
    }}},[_c('GmapMarker',{attrs:{"position":{
        lat: _vm.lat,
        lng: _vm.lng,
      }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }